// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__X0YnM","gif":"Loading_gif__2wX5j"};